export default {
  title: 'Descarga SOSAFE',
  description: 'Cuidémonos entre todos. ¡Cuanto más somos, más seguros estaremos!',
  googlePlayButton: 'Descargar en Google Play',
  appGalleryButton: 'Descargar en AppGallery',
};
